import React from 'react';
import { Comment } from '../types/socialGlass';

interface CommentListProps {
  comments: Comment[];
  showUsernamePrefix?: boolean;
}

const CommentList: React.FC<CommentListProps> = ({ 
  comments, 
  showUsernamePrefix = false 
}) => {
  return (
    <div className="hide-scrollbar flex max-h-40 flex-col gap-1 overflow-y-auto pr-1">
      {comments.map((comment, cidx) => (
        <div
          key={cidx}
          className="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white px-2 py-1 sm:flex-row sm:items-center"
        >
          <div className="flex flex-1 flex-col">
            <span className="text-xs font-bold text-gray-800">
              {showUsernamePrefix ? `@${comment.user.name}` : comment.user.name || "Missing"}
            </span>
            <span className="text-xs text-gray-700">
              {comment.text || "Missing"}
            </span>
          </div>
          <div className="flex min-w-[36px] flex-col items-center gap-1 text-xs font-semibold text-[#DB4225]">
            <svg
              width="18"
              height="18"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                  2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 
                  4.5 2.09C13.09 3.81 14.76 3 16.5 
                  3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                  6.86-8.55 11.54L12 21.35z"
                fill="#DB4225"
              />
            </svg>
            <span>~{comment.likes}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommentList;
